import { assert } from '../../../app/logger.js';
import { PolylineBaseMixin } from '../base/polyline_base_mixin.js';
import { LayerGoogleMaps } from './layer_googlemaps.js';

/**
 * A wrapper around GoogleMaps polyline.
 */
class PolylineGoogleMaps extends PolylineBaseMixin(LayerGoogleMaps) {
  get path() {
    return this.native
      .getPath()
      .getArray()
      .map(p => ({
        lat: p.lat(),
        lng: p.lng(),
      }));
  }

  set path(v) {
    assert(v instanceof Array, `[map:polyline:googlemaps] no path`);
    this.native.setPath(v);
  }

  // Protected

  createNative() {
    return new window.google.maps.Polyline(this.nativeOptions);
  }

  static getDefaultNativeOptions() {
    return {
      geodesic: true,
      strokeColor: 'red',
    };
  }

  static get nativeOptionsMapper() {
    return Object.assign({}, super.nativeOptionsMapper, {
      path: 'path',
      color: 'strokeColor',
      weight: 'strokeWeight',
    });
  }
}

export { PolylineGoogleMaps };
